export const customAttributes = new Map<string, string | undefined>([
  ['e2e_test', 'off'],
]);
